import URLSearchParams from 'url-search-params'
import {
  FILTER_MORE,
  FILTER_CLEAR,
  FILTER_CODE,
  SEARCH_PARAM_PRICE_RANGE_DYNAMIC, SEARCH_PARAM_AMENITIES, SEARCH_PARAM_HOTEL_TYPE,
} from '../../constants'

import codeApply, { codeClear } from './professionalCode'
import setValue from "../../../shared/actions/setValue";

const filterClear = (filterType, doApply, dispatch, code) => {
  const params = new URLSearchParams(window.location.search)

  switch (filterType) {
    case FILTER_MORE: {
      [SEARCH_PARAM_PRICE_RANGE_DYNAMIC, SEARCH_PARAM_AMENITIES, SEARCH_PARAM_HOTEL_TYPE]
        .forEach((param) => {
          if (params.has(param)) {
            params.delete(param)
          }
        })
      break
    }
    case FILTER_CODE: {
      dispatch(codeClear(code)).then(() => {
        // hack to load page without cache to recive new drupal settings
        window.location.href = window.location.href
      })
      break
    }
    default: break
  }

  const paramsString = Array.from(params.entries()).length > 0 ? `?${params.toString()}` : ''
  window.history.replaceState({}, '', paramsString || window.location.pathname)
  dispatch(setValue('queryString', paramsString))

  dispatch({ type: FILTER_CLEAR, filterType, doApply })
}

export default (
  filterType, doApply = true, code,
) => dispatch => filterClear(filterType, doApply, dispatch, code)
